import styled from 'styled-components';

const TabsWrapper = styled.section`
  margin-top: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #ccdde6;
`;

export default TabsWrapper;
